var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "required-email-notice",
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("SendEmail.notice.title"),
        width: "800px",
        top: "5vh",
        "z-index": 4000,
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.preventClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c("template", { slot: "title" }, [
        _c("div", { staticClass: "notice-title" }, [
          _c("i", {
            staticClass: "el-icon-message-solid notice-icon",
            attrs: { "aria-hidden": "true" },
          }),
          _c("span", [_vm._v(_vm._s(_vm.$t("SendEmail.notice.title")))]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "notice-body" },
        [
          _vm.currentEmail
            ? [
                _c("div", { staticClass: "notice-field" }, [
                  _c("div", { staticClass: "notice-label" }, [
                    _vm._v(_vm._s(_vm.$t("SendEmail.table.EmailTitle"))),
                  ]),
                  _c("div", { staticClass: "notice-value" }, [
                    _vm._v(_vm._s(_vm.currentEmail.mailTitle)),
                  ]),
                ]),
                _c("div", { staticClass: "notice-field" }, [
                  _c("div", { staticClass: "notice-label" }, [
                    _vm._v(_vm._s(_vm.$t("SendEmail.table.EmailContent"))),
                  ]),
                  _c(
                    "div",
                    {
                      ref: "content",
                      staticClass: "notice-value notice-content",
                    },
                    [_vm._v(_vm._s(_vm.currentEmail.content))]
                  ),
                ]),
                _vm.attachments.length
                  ? _c(
                      "div",
                      { staticClass: "notice-field" },
                      [
                        _c("div", { staticClass: "notice-label" }, [
                          _vm._v(_vm._s(_vm.$t("SendEmail.table.Multiples"))),
                        ]),
                        _vm._l(_vm.attachments, function (file, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "notice-attachment" },
                            [
                              _c("i", {
                                staticClass: "el-icon-document",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _c("span", { staticClass: "attachment-name" }, [
                                _vm._v(_vm._s(file.name)),
                              ]),
                              _c("el-button", {
                                attrs: {
                                  type: "text",
                                  icon: "el-icon-download",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadAttachment(file)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "notice-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-checkbox",
            {
              staticClass: "notice-acknowledgement",
              attrs: {
                disabled: _vm.loading || _vm.submitting || !_vm.currentEmail,
              },
              model: {
                value: _vm.acknowledged,
                callback: function ($$v) {
                  _vm.acknowledged = $$v
                },
                expression: "acknowledged",
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("SendEmail.notice.acknowledgement")) + " "
              ),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                disabled: !_vm.acknowledged || _vm.loading || !_vm.currentEmail,
                loading: _vm.submitting,
              },
              on: { click: _vm.confirmEmail },
            },
            [_vm._v(" " + _vm._s(_vm.$t("okText")) + " ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }